<template>
  <v-icon :color="color" :style="style">{{ icon }}</v-icon>
</template>

<script>
export default {
  name: 'RotateIcon',
  props: {
    icon: {
      type: String,
    },
    color: {
      type: String,
    },
    rotateDuration: {
      type: Number,
      default: 500,
    },
    rotation: {
      type: Number,
      default: 180,
    },
    trigger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      style: `transition: all ${this.rotateDuration}ms;transform: rotate(0deg)`,
      currentRotation: 0,
    };
  },

  watch: {
    trigger(newValue, oldValue) {
      if (newValue !== oldValue) {
        setTimeout(() => {
          this.style = `transition: all ${this.rotateDuration}ms;opacity:1;transform: rotate(${this.currentRotation}deg)`;
        }, this.rotateDuration / 2);
        this.currentRotation = this.currentRotation === 0 ? this.rotation : 0;
        this.style = `transition: all ${this.rotateDuration}ms;opacity:0;transform: rotate(${this.currentRotation}deg)`;
      }
    },
  },
};
</script>
